import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { DyeingForecastSearchCommand } from '../../models/production/commands/dyeing-forecast-search-command';
import { DyeingForecast } from '../../models/production/dyeing/dyeing-forecast';

import { getSkipperErrorHeader } from '@app/utilities/error-header.util';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class DyeingForecastProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/dyeing-forecast';

  public getById(id: string): Observable<ApiResponse<DyeingForecast>> {
    return this.httpClient.get<ApiResponse<DyeingForecast>>(`${this.baseUrl}/${id}`);
  }

  public search(searchCommand: DyeingForecastSearchCommand, avoidInterceptor = false): Observable<ApiResponse<DyeingForecast[]>> {
    const headers = getSkipperErrorHeader(avoidInterceptor);
    return this.httpClient.post<ApiResponse<DyeingForecast[]>>(`${this.baseUrl}/search`, searchCommand, { headers });
  }

  public create(dyeingForecast: DyeingForecast): Observable<ApiResponse<DyeingForecast>> {
    return this.httpClient.post<ApiResponse<DyeingForecast>>(`${this.baseUrl}`, dyeingForecast);
  }

  public update(dyeingForecast: DyeingForecast): Observable<ApiResponse<DyeingForecast>> {
    return this.httpClient.put<ApiResponse<DyeingForecast>>(`${this.baseUrl}/${dyeingForecast.id}`, dyeingForecast);
  }

  public complete(id: string): Observable<ApiResponse<DyeingForecast>> {
    return this.httpClient.post<ApiResponse<DyeingForecast>>(`${this.baseUrl}/${id}/complete`, {});
  }
}
